module.exports = __webpack_public_path__ + "static/media/ios-permission-step-3.e753860f.png";